import 'magnific-popup';

$(document).ready(function() {
	$('.js-slider-image').magnificPopup({
			type: 'image',
			closeOnContentClick: true,
			mainClass: 'mfp-with-zoom',
			zoom: {
		    enabled: true,

		    duration: 350,
		    easing: "ease-in-out",
		  },
			image: {
			verticalFit: true
		},
	});
	$('.partner-video-link').magnificPopup({
		type:'inline',
		midClick: true,
		callbacks: {
			open: function() {
			  let currentVideo = this.currItem.inlineElement.find('video');
			  console.log(currentVideo);
			  currentVideo.trigger('play');
			},
			close: function() {
				let currentVideo = this.currItem.inlineElement.find('video');
				  console.log(currentVideo);
				  currentVideo.trigger('pause');
			  // Will fire when popup is closed
			}
			// e.t.c.
		  }
	});
});

